import { useState, useEffect, useCallback } from 'react';
import { Pane, Heading, Text, Button, toaster } from 'evergreen-ui';
import { TrashIcon } from 'evergreen-ui';
import { getAllFieldNames, deleteFieldGlobally } from '../services/guestExtraFieldsService';

const GuestExtraFieldsManager = () => {
    const [fieldNames, setFieldNames] = useState([]);

    const load = useCallback(async () => {
        try {
            const names = await getAllFieldNames();
            setFieldNames(names || []);
        } catch {
            // silently fail
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleDelete = async (fieldName) => {
        if (!window.confirm(`Eliminare il campo "${fieldName}" da tutti gli ospiti?`)) return;
        try {
            await deleteFieldGlobally(fieldName);
            toaster.success(`Campo "${fieldName}" eliminato da tutti gli ospiti`);
            setFieldNames(prev => prev.filter(n => n !== fieldName));
        } catch {
            toaster.danger("Errore durante l'eliminazione del campo");
        }
    };

    if (fieldNames.length === 0) return null;

    return (
        <Pane marginTop={24} marginBottom={16} padding={16} background="tint2" borderRadius={4}>
            <Heading size={400} marginBottom={4}>Gestione campi personalizzati</Heading>
            <Text size={300} color="muted" display="block" marginBottom={12}>
                Per aggiungere un nuovo campo vai nella modifica di un ospite, sezione "Campi personalizzati", e usa il modulo "+ Aggiungi campo". Il campo diventerà disponibile per tutti gli ospiti. Da qui puoi solo eliminare un campo da tutti gli ospiti contemporaneamente.
            </Text>
            <Pane display="flex" flexDirection="column" gap={8}>
                {fieldNames.map(name => (
                    <Pane key={name} display="flex" alignItems="center" gap={12}>
                        <Text flex={1}>{name}</Text>
                        <Button
                            iconBefore={TrashIcon}
                            intent="danger"
                            height={28}
                            onClick={() => handleDelete(name)}
                        >
                            Elimina da tutti gli ospiti
                        </Button>
                    </Pane>
                ))}
            </Pane>
        </Pane>
    );
};

export default GuestExtraFieldsManager;
